import { useTranslation } from 'react-i18next';
import { Alert, Box, CircularProgress, Grid, Stack } from '@mui/material';
import { MetricsKpiCards } from './MetricsKpiCards';
import { ProjectsByStatusPanel } from './ProjectsByStatusPanel';
import { UsageSummaryPanel } from './UsageSummaryPanel';
import { resolveMetricLocale } from './formatNumber';

/**
 * @param {'platform' | 'organization'} scope
 */
export function PlatformMetricsView({ metrics, isLoading, error, scope = 'platform' }) {
  const { t, i18n } = useTranslation();
  const locale = resolveMetricLocale(i18n.language);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return <Alert severity="error">{error.message || t('common.error')}</Alert>;
  }

  if (!metrics) {
    return null;
  }

  return (
    <Stack spacing={{ xs: 2, sm: 3 }}>
      <MetricsKpiCards metrics={metrics} scope={scope} locale={locale} />

      <Grid container spacing={{ xs: 2, sm: 2.5 }}>
        <Grid item xs={12} lg={7}>
          <ProjectsByStatusPanel projects={metrics.projects} locale={locale} />
        </Grid>
        <Grid item xs={12} lg={5}>
          <UsageSummaryPanel metrics={metrics} scope={scope} locale={locale} />
        </Grid>
      </Grid>
    </Stack>
  );
}
